import React, { useEffect, useState } from 'react';
import Header from '../../../../../component/common/landing-page/widgets/Header';
import axios from 'axios';

export default function Terms() {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTerms = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_NODE_API_URL}/organization-details`
                );
                if (res.data?.data?.terms_of_use) {
                    setContent(res.data.data.terms_of_use);
                }
            } catch (e) {
                console.error('Error loading terms:', e);
            }
            setLoading(false);
        };
        fetchTerms();
    }, []);

    return (
        <div className='d-flex flex-column landing-page-wrapper'>
            <Header />
            <div className="flex-grow-1 main-content-wrap">
                <div className="content-section section-padding right-media">
                    <div className="container">
                        <div className="text-wrap content-page-wrapper">
                            {loading ? (
                                <div className="text-center py-5">
                                    <span className="spinner-border spinner-border-sm" role="status"></span>
                                    <span className="ms-2">Loading...</span>
                                </div>
                            ) : content ? (
                                <div className="text-part" dangerouslySetInnerHTML={{ __html: content }} />
                            ) : (
                                <p style={{ color: '#666' }}>No terms of use content has been added yet.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
